import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useModalContext } from '../../context.mjs';
import { StyledPortalContainer } from '../../styled.mjs';
import { portalContainer } from './portalContainer.vanilla.mjs';

const ModalPortalContainer = forwardRef(({ className: classNameFromProps, ...props }, ref) => {
  const { onPortalContainerElementChange } = useModalContext(
    "Modal.PortalContainer"
  );
  const composedRef = useComposedRefs(ref, onPortalContainerElementChange);
  const className = classNames(portalContainer, classNameFromProps);
  return /* @__PURE__ */ jsx(StyledPortalContainer, { className, ref: composedRef, ...props });
});

export { ModalPortalContainer };
//# sourceMappingURL=PortalContainer.mjs.map
